module.exports = __webpack_public_path__ + "officialStatic/img/logo26.a45d8ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/logo26.png
// module id = uxtb
// module chunks = 0